import React from 'react';
import { motion } from 'framer-motion';
interface Metric {
  label: string;
  value: string;
}
interface MetricsBarProps {
  metrics: Metric[];
}
export function MetricsBar({
  metrics
}: MetricsBarProps) {
  return <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-4 mb-6 lg:mb-8" data-id="element-831">
      {metrics.map((metric, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.05
    }} className="bg-white dark:bg-gray-900 p-3 sm:p-4 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800" data-id="element-832">
          <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-1 uppercase tracking-wider" data-id="element-833">
            {metric.label}
          </p>
          <p className="text-sm sm:text-lg font-bold text-gray-900 dark:text-white truncate" data-id="element-834">
            {metric.value}
          </p>
        </motion.div>)}
    </div>;
}